import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faClock } from '@fortawesome/pro-light-svg-icons';

export type ProLightClockProps = IconComponentProps;

export const ProLightClock = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightClockProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faClock}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faClock}
    />
  );
};

ProLightClock.displayName = 'ProLightClock';
